function getPrices(currency) {
  const endpoint = 'https://backend.heurekaprints.de/currency/' + currency + '/starmap/prices';
  const requestOptions = {
  method: "GET",
  redirect: "follow"
  };

  const response = fetch(endpoint, requestOptions);
  return response;
};